import {apiGetRequest, apiPostRequest, cdnGetRequest,} from "../utils/webrequests";
  import { SessionInfo } from "../data/SessionData";
import { UserSessionEventData } from "../data/UserSessionEventData";
  
  
  export async function getUserSessions(CurrentId: string): Promise<UserSessionEventData> {
    const data: UserSessionEventData = await apiGetRequest("GetUserSessions?id=" + CurrentId, null);
    return data;
  }
  
  
  export async function deleteUserSession(sessionInfo: SessionInfo, userId: string): Promise<any> {
    const payload = { ...sessionInfo, UserId: userId };
    
    const data = await apiPostRequest("RemoveUserSession", payload);
    return data;
  }

  export async function updateUserSession(sessionInfo: SessionInfo, userId: string): Promise<any> {
  const payload = { ...sessionInfo, UserId: userId };

  const data = await apiPostRequest("UpdateUserSessions", payload);
  return data;
}